export default __webpack_public_path__ + "static/media/video.87d700eb.png";